/** Faculty Diary & Lesson Plan path constants. */

export const FACULTY_DIARY_PATH = '/faculty/diary';
export const FACULTY_DIARY_DAY_PATH = '/faculty/diary/day';
export const FACULTY_DIARY_COMPOSE_PATH = '/faculty/diary/compose';
export const FACULTY_DIARY_ENTRY_PATH = (id) => `/faculty/diary/entries/${id}`;
export const FACULTY_DIARY_ENTRY_EDIT_PATH = (id) => `/faculty/diary/entries/${id}/edit`;

export const FACULTY_LESSON_PLANS_PATH = '/faculty/lesson-plans';
export const FACULTY_LESSON_PLAN_NEW_PATH = '/faculty/lesson-plans/new';
export const FACULTY_LESSON_PLAN_IMPORT_PATH = '/faculty/lesson-plans/import';
export const FACULTY_LESSON_PLAN_PATH = (id) => `/faculty/lesson-plans/${id}`;
export const FACULTY_LESSON_PLAN_EDIT_PATH = (id) => `/faculty/lesson-plans/${id}/edit`;
export const FACULTY_LESSON_PLAN_SESSIONS_PATH = (id) => `/faculty/lesson-plans/${id}/sessions`;

/** Teaching Reports — read-only projections over diary + lesson plans (Phase 3B/3C). */
export const FACULTY_TEACHING_REPORTS_PATH = '/faculty/teaching-reports';
export const ADMIN_TEACHING_REPORTS_PATH = '/admin/teaching-reports';

/** Session Library — reusable teaching material, never evidence (Phase 4B). */
export const FACULTY_SESSION_LIBRARY_PATH = '/faculty/session-library';
export const FACULTY_SESSION_LIBRARY_NEW_PATH = '/faculty/session-library/new';
export const FACULTY_SESSION_TEMPLATE_PATH = (id) => `/faculty/session-library/${id}`;
export const FACULTY_SESSION_TEMPLATE_EDIT_PATH = (id) => `/faculty/session-library/${id}/edit`;

export function facultyDiaryDayPath(dayKey) {
  return dayKey ? `${FACULTY_DIARY_DAY_PATH}/${dayKey}` : FACULTY_DIARY_DAY_PATH;
}
